import { normalizeSubscriberClass } from 'global/utils/election/subscriberClassHelper';
import { PersonInfo, Subscriber, SubscriberTask, EeClass } from 'types/electionService';

export const sortDependentsInSubscriber = (subscriber: Subscriber): Subscriber => {
  const sortedDependents = subscriber.custom.dependents.sort((a, b) => {
    const typeOrder: Record<string, number> = { S: 3, DP: 2, D: 1 };
    if (typeOrder[a.type] > typeOrder[b.type]) return -1;
    if (typeOrder[a.type] < typeOrder[b.type]) return 1;
    if (a.type === 'D' && b.type === 'D') {
      return a.firstName.localeCompare(b.firstName);
    }
    return 0;
  });
  return { ...subscriber, custom: { dependents: sortedDependents } };
};

export const findDependentById = (subscriber: Subscriber, dependentId: string): PersonInfo | null => {
  return subscriber.custom.dependents.find((dependent) => dependent.id === dependentId) || null;
};

export const getTaskByEntityId = (subscriber: Subscriber, entityId: string): SubscriberTask | null => {
  return subscriber.tasks?.find((task) => task.entityId === entityId) || null;
};

/**
 * Returns the subset of classes that are available for selection.
 * When the domain has availableClasses, only classes whose name (after normalization) is in that list are returned;
 * when availableClasses is empty, all classes are returned. Use for SubscriberCard so only available classes appear in the class dropdown.
 */
export const getClassesAvailableForSelection = (classes: EeClass[], availableClasses: string[]): EeClass[] => {
  if (availableClasses.length === 0) return classes;
  const normalizedAvailable = new Set(availableClasses.map(normalizeSubscriberClass));
  return classes.filter((eeClass) => normalizedAvailable.has(normalizeSubscriberClass(eeClass.name)));
};
